import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledDatePicker } from '../../../../../shared';

const ReferenceDateSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  return (
    <ControlledDatePicker
      fullWidth
      variant="outlined"
      control={control}
      name="reference_date"
      label={t('referenceDate')}
    />
  );
};

export default ReferenceDateSection;
